export const UMB_VALIDATION_EMPTY_LOCALIZATION_KEY = '#validation_invalidEmpty';
export const UMB_VALIDATION_MISSING_LOCALIZATION_KEY = '#validation_invalidNull';
export const UMB_VALIDATION_FALSE_LOCALIZATION_KEY = '#validation_invalidFalse';
